var divider_viewer_rtlignore_default = {
  "divider-container": "lVyTG",
  "divider-container--double": "QIevW",
  "divider": "O9I7h",
  "divider--single": "R-uzT",
  "divider--double": "oCXqL",
  "divider--dashed": "O6bcN",
  "divider--dotted": "_1Rrpy",
  "divider--small": "IGT-L",
  "divider--medium": "nWv7r",
  "divider--large": "Zsvip",
  "divider--left": "AKZ4q",
  "divider--center": "-OF5L",
  "divider--right": "_3IXmp",
  "svgFixerContainer": "p3IVm",
  "emptyChar": "vIIaf"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
